import React from 'react';
import { useLanguage } from '../context/LanguageProvider';
import { useThemeContext } from '../context/ThemeProvider';
import { generateAsciiTxt } from '../utils/asciiExporter';
import { saveAs } from 'file-saver';
import ActionButton from './common/ActionButton';
import type { AsciiExportButtonProps } from '../types';

const AsciiExportButton: React.FC<AsciiExportButtonProps> = ({ 
  grid, 
  instruments, 
  stepsPerBar, 
  bpm, 
  tempo,
  drumKitId, 
  timeSignature, 
  noteDivision, 
  disabled = false 
}): JSX.Element => {
  const { t } = useLanguage();
  const { getClass } = useThemeContext();

  const handleExport = (): void => {
    if (disabled) return;

    try {
      const actualBpm = bpm || tempo || 120;
      const asciiContent = generateAsciiTxt({
        grid,
        instruments,
        stepsPerBar,
        bpm: actualBpm,
        drumKitId,
        timeSignature,
        noteDivision
      });

      // 生成檔名，根據設定參數
      const timeSignatureForFile = timeSignature?.replace('/', '-') || '4-4';
      const noteDivisionForFile = noteDivision || '16n';
      const tempoForFile = actualBpm;
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-').substring(0, 19);
      const filename = `ascii-output-${timeSignatureForFile}-${noteDivisionForFile}-${tempoForFile}-${timestamp}.txt`;
      
      const blob = new Blob([asciiContent], { type: 'text/plain;charset=utf-8' });
      saveAs(blob, filename);
    } catch (error) {
      console.error('Export error:', error);
    }
  };

  return (
    <ActionButton
      onClick={handleExport}
      disabled={disabled}
      icon="📤"
      text={t('export')}
      tooltip={t('export')}
      variant="primary"
    />
  );
};

export default AsciiExportButton; 